<div class="row">
    <div class="col-md-12 col-xl-12 col-lg-12 pr-0">
        <globalafiliados></globalafiliados>
    </div>
</div>
<div class="row">
    <div class="col-md-12 col-xl-4 pr-0">
        <globalciudades></globalciudades>
    </div>
    <div class="col-md-12 col-xl-4 pr-0">
        <globalnuevosinactivos></globalnuevosinactivos>
    </div>
    <div class="col-md-12 col-xl-4 pr-0">
        <globalafiliadosporfatolio></globalafiliadosporfatolio>
    </div>
</div>